import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from 'react-bootstrap';

/**
 * Componente que renderiza a tabela de clientes.
 * @param {Array} rows - Dados das linhas da tabela.
 * @param {Array} columns - Definições das colunas da tabela.
 * @param {Function} onEdit - Função chamada ao clicar no botão de edição.
 * @param {Function} onDelete - Função chamada ao clicar no botão de remoção.
 */
function ClientTable({ rows, columns, onEdit, onDelete }) {
    // Cria as colunas, distribuindo o espaço de forma uniforme e adiciona a coluna de ações
    const enhancedColumns = [
      ...columns.map(col => ({
        ...col,
        flex: 1,        // Faz com que as colunas se expandam igualmente
        minWidth: 150,  // Garante uma largura mínima para evitar colunas muito estreitas
      })),
      {
        field: "actions",
        headerName: "Ações",
        width: 150,      // Largura fixa para os botões de ação
        sortable: false,
        renderCell: (params) => (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>
            <Button
              variant="info"
              size="sm"
              onClick={() => onEdit(params.row.id)}
            >
              <i className="fa fa-edit"></i>
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => onDelete(params.row.id)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        ),
      }
    ];
  
    return (
      // Container com altura fixa para possibilitar scroll interno
      <div style={{ width: '100%', height: '500px' }}>
        <DataGrid
          rows={rows}
          columns={enhancedColumns}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          disableSelectionOnClick
          sx={{
            fontSize: '1.1rem', // Aumenta a fonte do conteúdo
            // Estilização do cabeçalho
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              fontWeight: 'bold',
              fontSize: '1.2rem',
              borderBottom: '1px solid #ccc',
            },
            // Estilização das células
            '& .MuiDataGrid-cell': {
              padding: '12px',
            },
            // Estilização do rodapé (caso esteja visível)
            '& .MuiDataGrid-footerContainer': {
              backgroundColor: '#fafafa',
              borderTop: '1px solid #ccc',
            },
            // Permite o scroll vertical interno
            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto',
            },
            // Remove bordas padrão para um visual mais limpo
            '& .MuiDataGrid-root': {
              border: 'none',
            },
          }}
        />
      </div>
    );
  }
  
  export default ClientTable;